import {
  Component,
  OnInit,
  Input,
  HostListener,
} from "@angular/core";
import { ChartData } from "chart.js";

@Component({
  selector: "common-chart",
  templateUrl: "./common-chart.component.html",
  styleUrls: ["./common-chart.component.scss"],
})
export class CommonChartComponent implements OnInit{
  @Input() request: any;
  @Input() title: string;
  @Input() type: string;
  @Input() chartOptions: any;
  @Input() options: {
    field: string;
    field2?: string;
    label: string;
  };
  @Input() colors: string[];

  public dataAll: any[];
  public data: ChartData = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  };
  public _noData: ChartData = {
    labels: ["Cargando..."],
    datasets: [
      {
        data: [1],
        backgroundColor: ["lightgray"],
      },
    ],
  };

  public typeBar: string = "bar";
  public years: number[] = [];
  public filteredData: any[];
  public yearsDropdownOptions: {label: string, value: string | number}[] = []
  
  constructor() {}

  ngOnInit() {
    this.dataAll = this.request;
    if (this.dataAll) {
      this.years = this.getUniqueYears(this.dataAll, this.options.label);
      this.yearsDropdownOptions = [{label: 'Todos', value: 'All'}, ...this.years.map(year => ({label: year.toString(), value: year}))]
      this.filteredData = this.dataAll;
      this.formatData();
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.formatData();
  }

  formatData() {
    const isMobile = window.innerWidth < 768;
    let values: any[];

    values = this.filteredData
      .filter((it) => it && it[this.options.label])
      .map((it) => ({
        [this.options.label]: it[this.options.label],
        [this.options.field]: +it[this.options.field],
        [this.options.field2]: this.options.field2
          ? +it[this.options.field2]
          : null,
      }));

    let data =
      this.type === "line"
        ? values
        : values
            .sort((a, b) => b[this.options.field] - a[this.options.field])
            .slice(0, 6);
    let dataLabel = data.slice(0, isMobile ? 3 : data.length);

    switch (this.type) {
      case "bar":
        this.data = {
          labels: data.map((it) => it[this.options.label]),
          datasets: [
            {
              label: "",
              data: data.map((it) => it[this.options.field]),
              backgroundColor: this.colors.slice(0, data.length),
            },
          ],
        };
        break;
      case "stackedBar":
        this.data = {
          labels: data.map((it) => it[this.options.label]),
          datasets: [
            {
              type: "bar",
              label: this.options.field,
              backgroundColor: "#BBDEF0",
              data: data.map((it) => it[this.options.field]),
            },
            {
              type: "bar",
              label: this.options.field2,
              backgroundColor: "#00A6A6",
              data: data.map(
                (it) => (it[this.options.field2] / 100) * it[this.options.field]
              ),
            },
          ],
        };
        break;
      case "line":
        this.data = {
          labels: data.map((it) => it[this.options.label].split("-", 1)),
          datasets: [
            {
              label: "Consumo",
              data: data.map((it) => it[this.options.field]),
              fill: false,
              borderColor: "#BBDEF0",
            },
            {
              label: "Factura",
              data: data.map((it) => it[this.options.field2]),
              fill: false,
              borderColor: "#00A6A6",
            },
          ],
        };
        break;
      default:
        this.data = {
          labels: dataLabel.map((it) => it[this.options.label]),
          datasets: [
            {
              label: "",
              data: data.map((it) => it[this.options.field]),
              backgroundColor: this.colors.slice(0, data.length),
            },
          ],
        };
    }
  }

  public getChartOptions(): any {
    if (this.chartOptions) {
      return this.chartOptions;
    }
    return undefined;
  }

  
  private getUniqueYears(data: any[], dateField: string): number[] {
    const years = data.map((item) => new Date(item[dateField]).getFullYear());
    return Array.from(new Set(years));
  }

  public filterDataByYear(year: string) {
    const yearNum = parseInt(year);
    this.filteredData =
      year === "All"
        ? this.dataAll
        : this.dataAll.filter(
            (item) =>
              new Date(item[this.options.label]).getFullYear() === yearNum
          );
    this.formatData();
  }
}
